export default __webpack_public_path__ + "static/media/warning-triangle.8ec0bb2e.svg";